import {restore} from 'effector'
import {using} from 'forest'
// import {appDefinition} from './appDef'
// import {Devtool} from './Devtool'
import {UnitReport} from './UnitReport'

import appSnap from './data/snapD.json'

const appDef = restore(appSnap)

using(document.body, () => {
  UnitReport(appDef)
})
